export interface RectCache {
  current: DOMRect;
  destroy: () => void;
}

export function createRectCache(element: HTMLElement | SVGElement): RectCache {
  let rect = element.getBoundingClientRect();
  const update = () => {
    rect = element.getBoundingClientRect();
  };
  window.addEventListener("scroll", update, { passive: true, capture: true });
  window.addEventListener("resize", update, { passive: true });
  return {
    get current() {
      return rect;
    },
    destroy() {
      window.removeEventListener("scroll", update, { capture: true });
      window.removeEventListener("resize", update);
    },
  };
}
